import { Details } from '@ria-client/tw-shared-ui';
import { ChevronDown } from 'lucide-react';
import { type ReactNode, useId } from 'react';

export interface FaqProps {
  faqs: {
    question: ReactNode;
    answer: ReactNode;
    initiallyExpanded?: boolean;
  }[];
}

export function Faq({ faqs }: FaqProps) {
  const id = useId();

  return (
    <ul className="m-0 list-none p-0">
      {faqs.map((faq, index) => (
        <li
          className="first:border-t border-b border-border"
          data-testid="accordion-wrapper"
          key={`faq-question-${index}`}
        >
          <Details
            className="w-full"
            detailsProps={{ open: faq.initiallyExpanded }}
            summaryComponentProps={{
              'aria-controls': `${id}-content-${index}`,
              className:
                'w-full justify-between px-2 py-3 sm:hover:bg-secondary sm:hover:outline sm:hover:outline-2 sm:hover:outline-ring',
              'data-testid': 'accordion-summary',
              id: `${id}-header-${index}`,
            }}
            SummaryComponent={
              <span className="flex w-full items-center justify-between">
                <span aria-level={3} className="typography-text-bold" role="heading">
                  {faq.question}
                </span>
                <ChevronDown
                  aria-hidden="true"
                  className="size-5 opacity-50 transition-transform duration-300 group-open:rotate-180"
                />
              </span>
            }
            variant="simple"
          >
            <div className="p-6" data-testid="accordion-details" id={`${id}-content-${index}`}>
              {faq.answer}
            </div>
          </Details>
        </li>
      ))}
    </ul>
  );
}
